import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import components from '../components/index.js';

export default {
  setup: function (store) {
    const routes = [

      {
        path: '*',
        name: '404',
        component: components.NotFound
      },
      {
        path: '/',
        name: 'root',
        redirect: '/products'
      },
      {
        path: '/products',
        name: 'products',
        component: components.TheProducts
      },
      // {
      //   path: '/orders',
      //   name: 'orders',
      //   component: components.OrderHistory
      // },
      {
        path: '/login',
        name: 'login',
        component: components.TheLogin
      }
    ];

    const router = new VueRouter({
      mode: 'history',
      routes
    });

    router.beforeEach(loadUser);

    async function loadUser (to, from, next) {
      if (to.query?.code || to.query?.token) {
        await store.dispatch('validateUser', { code: to.query.code, token: to.query.token });
        delete to.query.code;
      } else if (!store.state.userToken) {
        await store.dispatch('initializeAuth');
      }

      const toLogin = to.path === '/login';
      const token = Cookies.get('user-token');
      const isAuthenticated = store.getters.isAuthenticated || token;

      if (toLogin && isAuthenticated) {
        next('/');
      } else if (!toLogin && !isAuthenticated) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    }
    return router;
  }
};
